import appStoreIcon from 'public/AppStore.svg';
import facebookIcon from 'public/facebook.svg';
import googlePlayIcon from 'public/GooglePlay.svg';
import instagramIcon from 'public/instagram.svg';
import twitterIcon from 'public/twitter.svg';

export { appStoreIcon, googlePlayIcon, facebookIcon, instagramIcon, twitterIcon };
